import { render } from "./viewTasks.html?vue&type=template&id=d9803aec&scoped=true&ts=true&external"
import script from "./ViewTasks.vue?vue&type=script&lang=ts"
export * from "./ViewTasks.vue?vue&type=script&lang=ts"

import "./ViewTasks.vue?vue&type=style&index=0&id=d9803aec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9803aec"]])

export default __exports__